export default "__VITE_ASSET__699be198__"